var l = /* @__PURE__ */ ((n) => (n.Stack = "stack", n.Block = "block", n.Inline = "inline", n.InlineFlex = "inlineFlex", n.InlineEqualWidth = "inlineEqualWidth", n))(l || {});
const e = [
  "stack",
  "block",
  "inline",
  "inlineFlex",
  "inlineEqualWidth"
];
export {
  e as RADIO_GROUP_LAYOUTS,
  l as RadioGroupLayout
};
